import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityPeopleEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-people-embed',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/people/embed',
	query: [],
};
